// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
__webpack_require__.O(undefined, ["css/bundle"], () => (__webpack_require__("./resources/js/App.js")))
var __webpack_exports__ = __webpack_require__.O(undefined, ["css/bundle"], () => (__webpack_require__("./resources/less/App.less")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
